import React from 'react';
import { XCircleIcon } from 'lucide-react';
import { SectionWrapper } from './ui';
export const PainPoints = () => {
  const pains = ['Aceptás mascotas de palabra sin ningún respaldo legal', 'No tenés ficha médica y si el animal tiene una reacción no sabés qué hacer', 'Si algo sale mal no tenés nada que te proteja', 'Cobrás menos de lo que valés porque no podés justificar un precio más alto', 'El dueño no confía del todo porque no recibe reportes ni seguimiento'];
  return <SectionWrapper className="bg-dark-bg" data-id="element-98">
      <div className="max-w-4xl mx-auto" data-id="element-99">
        <div className="text-center mb-12" data-id="element-100">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-6" data-id="element-101">
            ¿Cuántos servicios más vas a dar{' '}
            <span className="text-accent border-b-4 border-accent" data-id="element-102">
              sin respaldo?
            </span>
          </h2>
          <p className="text-xl text-gray-300 mb-4" data-id="element-103">
            Sos cuidador/a de mascotas. Amás los animales. Pero nadie te dijo
            que ibas a trabajar sin contrato, sin ficha médica y rezando para
            que no pase nada grave.
          </p>
          <p className="text-2xl font-bold text-primary" data-id="element-104">
            No es falta de experiencia. Es falta de un sistema.
          </p>
        </div>

        <div className="bg-dark-card border border-red-900/30 rounded-2xl p-6 md:p-10 shadow-2xl" data-id="element-105">
          <ul className="space-y-6" data-id="element-106">
            {pains.map((pain, index) => <li key={index} className="flex items-start gap-4" data-id="element-107">
                <XCircleIcon className="text-red-500 shrink-0 mt-1" size={24} data-id="element-108" />
                <span className="text-lg text-gray-300" data-id="element-109">{pain}</span>
              </li>)}
          </ul>
        </div>

        <div className="text-center mt-12" data-id="element-110">
          <h3 className="text-2xl md:text-3xl font-bold text-white" data-id="element-111">
            ¿Y si este fuera el{' '}
            <span className="text-primary" data-id="element-112">último servicio</span> que das sin
            respaldo?
          </h3>
        </div>
      </div>
    </SectionWrapper>;
};
export const CostTable = () => {
  const costs = [{
    sin: 'Sin contrato',
    costo: 'Un incidente puede costarte más de lo que ganaste en el año'
  }, {
    sin: 'Sin ficha médica',
    costo: 'No sabés qué hacer ni a quién llamar'
  }, {
    sin: 'Sin protocolo de emergencias',
    costo: '10 minutos de confusión pueden costarle la vida a una mascota'
  }, {
    sin: 'Sin reportes',
    costo: 'El cliente no vuelve ni recomienda'
  }];
  return <SectionWrapper className="bg-dark-card/30 border-t border-dark-border" data-id="element-113">
      <div className="max-w-5xl mx-auto" data-id="element-114">
        <div className="text-center mb-12" data-id="element-115">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-4" data-id="element-116">
            ⚖️ ¿CUÁNTO CUESTA <span className="text-red-500" data-id="element-117">NO TENERLO?</span>
          </h2>
        </div>

        <div className="overflow-x-auto rounded-xl border border-dark-border shadow-xl" data-id="element-118">
          <table className="w-full text-left border-collapse" data-id="element-119">
            <thead data-id="element-120">
              <tr className="bg-dark-card border-b border-dark-border" data-id="element-121">
                <th className="p-4 md:p-6 text-lg font-bold text-red-400 w-1/2" data-id="element-122">
                  Sin Kit Profesional
                </th>
                <th className="p-4 md:p-6 text-lg font-bold text-white w-1/2 border-l border-dark-border" data-id="element-123">
                  Costo real
                </th>
              </tr>
            </thead>
            <tbody data-id="element-124">
              {costs.map((item, i) => <tr key={i} className="border-b border-dark-border/50 hover:bg-dark-card/50 transition-colors" data-id="element-125">
                  <td className="p-4 md:p-6 text-gray-300 font-medium" data-id="element-126">
                    {item.sin}
                  </td>
                  <td className="p-4 md:p-6 text-gray-400 border-l border-dark-border/50" data-id="element-127">
                    {item.costo}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="text-center mt-12" data-id="element-128">
          <p className="text-white text-xl mb-2 font-medium" data-id="element-129">
            El próximo servicio puede ser diferente.
          </p>
          <p className="text-2xl text-primary font-bold italic" data-id="element-130">
            "El próximo servicio puede ser el primero con respaldo real." 🐾
          </p>
        </div>
      </div>
    </SectionWrapper>;
};